import { useLoadingText } from './useLoadingText';
import './LoadingText.css';

const LoadingText = ({ firstChunkArrived }: { firstChunkArrived: boolean }) => {
  const { text } = useLoadingText(firstChunkArrived);

  if (!text) return null;

  return (
    <span className='mb-2 inline-block text-sm font-medium text-gx-text-disabled after:inline-block after:w-0 after:overflow-hidden after:align-bottom after:content-["..."] after:animate-[loading-dots_1.5s_steps(4,end)_infinite]'>
      {text}
    </span>
  );
};

export default LoadingText;
